import { Link, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { ThemeToggle } from '../ThemeToggle';
import logoPrimary from '../../assets/branding/logo-primary-v2.svg';
import logoDark from '../../assets/branding/logo-dark-v2.svg';

export function FriendlyPublicLayout() {
  const location = useLocation();
  const { t } = useTranslation();

  const getManagementUrl = () => {
    if (typeof window === 'undefined') return '/';
    const baseDomain = window.location.hostname.replace(/^events\./, '');
    const port = window.location.port ? `:${window.location.port}` : '';
    return `${window.location.protocol}//${baseDomain}${port}/`;
  };

  const navLinks = [
    { label: t('nav.home'), href: '/' },
    { label: t('nav.events'), href: '/events' },
    { label: t('nav.scores'), href: '/scores' },
  ];

  const isActive = (href: string) => href === '/' ? location.pathname === '/' : location.pathname.startsWith(href);

  return (
    <div className={`public-shell public-shell--arena ${location.pathname !== '/' ? 'public-shell--inner' : ''}`}>
      <header className="site-header">
        <div className="site-header__main site-container">
          <Link to="/" className="site-brand" aria-label="Y / sports home">
            <img className="site-brand__logo site-brand__logo--light" src={logoPrimary} alt="Y / sports" />
            <img className="site-brand__logo site-brand__logo--dark" src={logoDark} alt="Y / sports" />
          </Link>

          <nav className="site-nav" aria-label="Primary navigation">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href} aria-current={isActive(link.href) ? 'page' : undefined} className={`site-nav__link ${isActive(link.href) ? 'is-active' : ''}`}>
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="site-header__actions">
            <ThemeToggle />
            <LanguageSwitcher />
            <a href={getManagementUrl()} className="button button--primary site-login">
              {t('nav.login')}
            </a>
          </div>
        </div>

        <nav className="mobile-nav site-container" aria-label="Mobile navigation">
          {navLinks.map((link) => (
            <Link key={link.href} to={link.href} aria-current={isActive(link.href) ? 'page' : undefined} className={`mobile-nav__link ${isActive(link.href) ? 'is-active' : ''}`}>
              {link.label}
            </Link>
          ))}
          <a href={getManagementUrl()} className="arena-mobile-login">{t('nav.login')} <span aria-hidden="true">↗</span></a>
        </nav>
      </header>

      <div className="site-container">
        <main className="site-main">
          <Outlet />
        </main>
      </div>

      <footer className="site-footer">
        <div className="site-container site-footer__inner">
          <div>
            <p className="site-footer__brand">Y / sports © {new Date().getFullYear()}</p>
            <p>{t('siteFooter.tagline')}</p>
          </div>
          <div className="site-footer__links">
            <Link to="/privacy">{t('landing.privacy')}</Link>
            <Link to="/account/delete">{t('landing.accountDeletion')}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
